import { encodeQueryValue } from './encodeQueryValue';

export const getModelLink = (
	modelLinkPath,
	modelLinkParameters,
	vehicle,
	noInventoryFallbackUrl,
	inventoryCounts = {}
) => {
	const modelKey = vehicle?.modelInv?.trim();
	const inventoryCount = inventoryCounts[modelKey] || 0;

	if (noInventoryFallbackUrl !== '' && inventoryCount === 0) {
		return noInventoryFallbackUrl.replace(/\$\{(\w+)\}/g, (_, key) => {
			const value = vehicle[key];
			return value != null ? encodeURIComponent(value) : '';
		});
	} else {
		const validParams = ['year', 'make', 'model', 'gvBodyStyle', 'trim'];
		const modelLinkParameterArray = modelLinkParameters
			.split(',')
			.reduce((paramsArray, currentParam) => {
				if (validParams.includes(currentParam)) {
					// Transforming to string in case of number
					const value =
						currentParam !== 'model'
							? vehicle[currentParam]?.toString()
							: vehicle?.modelInv?.toString();
					if (!value) {
						return paramsArray;
					}
					const encodedValue = encodeQueryValue(value);
					paramsArray.push(
						`${currentParam}=${encodedValue?.replace(/ /g, '+')}`
					);
				}
				return paramsArray;
			}, []);
		return `${modelLinkPath}?${modelLinkParameterArray.join('&')}`;
	}
};
